module.exports = __webpack_public_path__ + "img/image-search.b0e4d47d.png";